export const CHANGE = "CHANGE";
export const BATCH_CHANGE = "BATCH_CHANGE";
